import { FC } from "react";
import BemIt, { addClass } from "@gtechdoodler/bem-it";

import Icon from "../../../imagery/Icon";

import { StepperStepProps } from "./StepperStep.types";
import StyledStepperStep, {
	StyledStepBullet,
	StyledStepLabel,
} from "./styling/StepperStep.styles";

const StepperStep: FC<StepperStepProps> = ({
	children,
	className,
	status = "default",
	colorOn,
	onClick,
	...props
}) => {
	const block = new BemIt("StepperStep");

	const isCompleted = status === "completed";
	return (
		<StyledStepperStep
			className={addClass(className).after(block)}
			status={status}
			{...props}
		>
			<StyledStepBullet status={status} onClick={onClick}>
				{isCompleted && <Icon name="check" size="sm" color="light_1" />}
			</StyledStepBullet>
			<StyledStepLabel status={status} colorOn={colorOn} onClick={onClick}>
				{children}
			</StyledStepLabel>
		</StyledStepperStep>
	);
};

export default StepperStep;
